import { Download } from "lucide-react";

export const BrandSection = ({ id, eyebrow, title, intro, children }) => (
  <section className="mt-20" id={id} data-testid={`brand-section-${id}`}>
    <p className="font-mono text-xs uppercase tracking-[0.25em] text-sky-700">{eyebrow}</p>
    <h2 className="mt-2 font-display text-3xl font-semibold tracking-tight text-ink">{title}</h2>
    {intro && <p className="mt-3 max-w-2xl text-sm leading-relaxed text-slate-600 md:text-base">{intro}</p>}
    <div className="mt-8">{children}</div>
  </section>
);

export const DownloadLink = ({ href, label, testid }) => (
  <a href={href} download className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3.5 py-1.5 text-xs font-medium text-ink transition-colors hover:border-sky-600 hover:text-sky-700" data-testid={testid}>
    <Download className="h-3.5 w-3.5" />{label}
  </a>
);
